'use strict';

module.exports = {
  environment: 'production',
  auth0: {
    redirect_uri: process.env.REACT_APP_AUTH0_REDIRECT || "https://quizzical-newton-bf1059.netlify.app"
  }
};
